import React, { useEffect } from 'react';
import SwaggerUI, { SwaggerUIOptions } from 'swagger-ui';
import 'swagger-ui/dist/swagger-ui.css';
import useYamlParse from '../hooks/useYamlParse';
import { ConfigType } from '../types/configType';
import filterSpec from '../utils/filterSpec';
// @ts-ignore
import { SwaggerUIKongTheme } from 'swagger-ui-kong-theme';
import addSecurity from '../utils/addSecurity';
import addSecurityDescription from '../utils/addSecurityDescription';

interface Language {
  prismLanguage: string;
  target: string;
  client?: string;
}

interface SwaggerUIOptionsType extends SwaggerUIOptions {
  theme?: {
    swaggerAbsoluteTop?: string;
    hasSidebar?: boolean;
    languages?: Language[];
  };
}

const swaggerUIOptions: SwaggerUIOptionsType = {
  dom_id: '#ui-wrapper',
  docExpansion: 'list',
  deepLinking: true,
  defaultModelExpandDepth: 50,
  defaultModelRendering: 'model',
  filter: true,
  // @ts-ignore
  presets: [SwaggerUI.presets.apis, SwaggerUI.SwaggerUIStandalonePreset],
  // @ts-ignore
  plugins: [SwaggerUIKongTheme, SwaggerUI.plugins.DownloadUrl],
  layout: 'KongLayout',
  theme: {
    swaggerAbsoluteTop: '0px',
    hasSidebar: true,
    languages: [
      {
        prismLanguage: 'bash',
        target: 'shell',
        client: 'curl',
      },
      {
        prismLanguage: 'javascript',
        target: 'javascript',
      },
      {
        prismLanguage: 'python',
        target: 'python',
      },
      {
        prismLanguage: 'ruby',
        target: 'ruby',
      },
    ],
  },
};

function SwaggerLoader({ type, data, defaultUrl }: { type: string; data: ConfigType; defaultUrl: string }) {
  const getSpec = useYamlParse();

  const convertToAbsoluteUrl = (url: string) => {
    return url.replace('../', `${defaultUrl}`);
  };

  const absoluteUrl = convertToAbsoluteUrl(data.url);

  const fetchSpec = async () => {
    let spec = await getSpec(absoluteUrl);

    if (data.group) {
      spec = filterSpec(spec, data.group);
    }

    if (type === 'server') {
      spec = addSecurity(spec);
      spec = addSecurityDescription(spec, false);
    }

    SwaggerUI({
      ...swaggerUIOptions,
      spec,
      persistAuthorization: true,
    });
  };

  useEffect(() => {
    fetchSpec();
  });

  return <div id="ui-wrapper" />;
}

export default React.memo(SwaggerLoader);
